import { render, staticRenderFns } from "./startpage.vue?vue&type=template&id=42a80de4&"
import script from "./startpage.ts?vue&type=script&lang=ts&"
export * from "./startpage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports